
import WishlistsListingModal from './ListingModal.vue';

export default {
  components: {
    WishlistsListingModal,
  },

  props: {
    dealsCount: {
      type: Number,
      required: false,
      default: 0,
    },

    dealId: {
      type: Number,
      required: true,
    },

    forCollection: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      wishlists: [],
      showWishlistModal: false,
    };
  },

  computed: {
    requestErrorMessage() {
      return this.$store.getters['wishlists/errorMessage'];
    },

    wishlist() {
      return this.$store.getters['wishlists/wishlist'];
    },

    canChange() {
      // only for collections, do we care if user is owner
      if (this.forCollection) {
        return this.wishlist?.is_owner;
      }
      return true;
    },

    wishlistDeal() {
      return this.wishlist && this.wishlist.deals.find(
        (deal) => deal.id === this.dealId,
      );
    },

    dealsCountFormatted() {
      // Format number to compact notation, example: 16500 to 16.5K
      const formatter = Intl.NumberFormat('en', {
        notation: 'compact',
        minimumIntegerDigits: 1,
        maximumFractionDigits: 2,
      });

      return this.dealsCount && formatter.format(this.dealsCount);
    },

    inWishlist() {
      if (this.forCollection) {
        // special logic for when we have multiple deals in a collection page
        return this.wishlist && !!this.wishlist.deals.find(
          (deal) => deal.id === this.dealId,
        );
      }
      // the way saveList works, is it doesn't fetch the updated list
      // so we just need to check if the wishlist is in the store
      // which indicates we have selected and added to a list
      return this.wishlist;
    },
  },

  // TODO: Fetch doesn't work well on the PDP page for some reason
  // We should use fetch instead of mounted to have SSR.
  async mounted() {
    // TODO:: ENG-784 - should move this to a mixin and call at page level
    if (!this.wishlist) {
      await this.$store.dispatch('wishlists/getWishlists');

      if (this.requestErrorMessage && this.$toastr) {
        this.$toastr.e(this.requestErrorMessage);
        return;
      }
    }

    this.wishlists = this.$store.getters['wishlists/wishlists'];

    // if we're on a deal page, update to list where deal exists
    if (!this.forCollection) {
      // Search deal in wishlists
      const wishlist = this.wishlists.find(
        (x) => x?.deals.find((y) => y.id === this.dealId),
      );

      await this.$store.dispatch('wishlists/setWishlist', wishlist);
    }
  },

  methods: {
    async onClick() {
      if (!this.canChange) {
        // do nothing if we can't edit
        return;
      }

      if (!this.forCollection) {
        this.showWishlistModal = true;
      } else if (this.inWishlist) {
        await this.removeFromList();
      } else {
        await this.saveList();
      }
    },

    async removeFromList() {
      if (this.isProcessing) {
        return;
      }

      await this.$store.dispatch('wishlists/removeFromList', { wishlistDealId: this.wishlistDeal.wishlist_deal_id });

      if (this.requestErrorMessage) {
        this.$toastr.e(this.requestErrorMessage);
        return;
      }

      this.$toastr.s(`Removed from <strong>${this.wishlist.name}</strong> wishlist!`);

      this.$store.dispatch('wishlists/getWishlistsHeaderData', this.wishlist.slug);
    },

    async saveList() {
      if (this.isProcessing) {
        return;
      }

      const requestData = {
        // Used to add add to new wishlist
        user: this.$store.state.session.user.id,
        wishlist: this.wishlist.id,
        deal: this.dealId,
      };

      await this.$store.dispatch('wishlists/saveToList', requestData);

      if (this.requestErrorMessage) {
        this.$toastr.e(this.requestErrorMessage);
        return;
      }

      await this.$store.dispatch('wishlists/getWishlistsHeaderData', this.wishlist.slug);

      this.$toastr.s(`Saved to <strong>${this.wishlist.name}</strong> wishlist!`);
    },
  },
};
